'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bidHistory = require('./remote/bidHistory');

var BidHistory = {
    fetchBidHistory: _bidHistory.BidHistoryRemote.fetchBidHistory
};

exports.default = BidHistory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/bidHistory.js
// module id = 5qJt
// module chunks = 60